import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/HomeBlogs.css";

const HomeBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  // responsive count
  const getVisibleCount = () => {
    if (window.innerWidth <= 768) return 1; // mobile + tablet
    return 4; // desktop
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BLOGS_API_URL}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setBlogs(data.blogs);
      });
  }, []);

  // handle resize
  useEffect(() => {
    const onResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // auto slide
  useEffect(() => {
    if (blogs.length <= visibleCount) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev + visibleCount >= blogs.length ? 0 : prev + visibleCount
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [blogs, visibleCount]);

  const handleOpenBlog = (title) => {
    const slug = title.toLowerCase().replace(/\s+/g, "-");
    navigate(`/blog/${slug}`);
  };

  const visibleBlogs = blogs.slice(
    currentIndex,
    currentIndex + visibleCount
  );

  return (
    <div className="home-blogs">
      <h2 className="home-blogs-title">Blogs</h2>
      {/* <p className="home-blogs-subtitle">
        Insights & updates from our experts
      </p> */}

      <div
        className={`blogs-row ${
          visibleCount === 1 ? "single" : "multi"
        }`}
      >
        {visibleBlogs.map((blog) => (
          <div
            key={blog.id}
            className="blog-card-home"
            onClick={() => handleOpenBlog(blog.title)}
          >
            <img
              src={`${process.env.REACT_APP_BASE_URL}/uploads/${blog.image}`}
              alt={blog.title}
            />
            <div className="blog-card-content">
              <h3>{blog.title}</h3>
              <p>
                {(blog.content || "")
                  .split(" ")
                  .slice(0, 16)
                  .join(" ")}
                ...
              </p>
            <button className="read-more-btn">Read More</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeBlogs;
